import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { ErrorSnackbarComponent } from '../components/error-snackbar/error-snackbar.component';
import { InfoSnackbarComponent } from '../components/info-snackbar/info-snackbar.component';
import { WarnSnackbarComponent } from '../components/warn-snackbar/warn-snackbar.component';
import { SnackbarActions } from '../types/snackbar-actions';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackbar: MatSnackBar) {}

  displayInfo(message: string): MatSnackBarRef<InfoSnackbarComponent> {
    return this.snackbar.openFromComponent(
      InfoSnackbarComponent,
      this.getConfig(message, SnackbarActions.OK, { duration: 3000 }),
    );
  }

  displayQuickInfo(message: string): MatSnackBarRef<any> {
    return this.snackbar.open(message, undefined, { duration: 2000 });
  }

  displayWarning(message: string): MatSnackBarRef<WarnSnackbarComponent> {
    return this.snackbar.openFromComponent(WarnSnackbarComponent, this.getConfig(message, SnackbarActions.CLOSE));
  }

  displayError(message: string): MatSnackBarRef<ErrorSnackbarComponent> {
    return this.snackbar.openFromComponent(ErrorSnackbarComponent, this.getConfig(message, SnackbarActions.DISMISS));
  }

  closeAll() {
    this.snackbar.dismiss();
  }

  private getConfig(message: string, action: string, options: MatSnackBarConfig<any> = {}): MatSnackBarConfig {
    return {
      data: { action, message, ...options },
    };
  }
}
